import React from "react";
import SelectOption from "./components/SelectOption";

const skinDyingOptions = [
  {
    value: false,
    label: "なし",
  },
  {
    value: true,
    label: "あり",
  },
];

function SelectSkinDying(props) {
  const { selectedValue, onSelect, isReadonly } = props;

  return (
    <div className="w-full h-full border border-solid border-[#B3B3B3] bg-white rounded-[10px]">
      <div className="w-full h-full flex flex-col justify-start gap-2.5 p-2">
        <SelectOption
          label={skinDyingOptions[0].label}
          value={skinDyingOptions[0].value}
          onSelect={onSelect}
          isSelected={selectedValue === skinDyingOptions[0].value}
          width="123px"
          isReadonly={isReadonly}
        />
        <SelectOption
          label={skinDyingOptions[1].label}
          value={skinDyingOptions[1].value}
          onSelect={onSelect}
          isSelected={selectedValue === skinDyingOptions[1].value}
          width="123px"
          isReadonly={isReadonly}
          note={'※着色により判定が困難な場合、参考データとして取り扱うことがありますので、ご了承ください。'}
        />
      </div>
    </div>
  );
}

export default SelectSkinDying;
